import reactGA from "react-ga4"

const eventTracker = (category: string, action: string, label: string) => {
    reactGA.event({category, action, label})
}

const trackPageView = (page_title: string) => {
    reactGA.send({ hitType: `pageview`, page_title: page_title})
}

export{
    eventTracker,
    trackPageView,
}